import { useTranslation } from 'react-i18next';
import type { TranslationKey } from 'src/types';
import { Badge } from 'src/components/atoms/Badge';
import { BadgeVariant } from 'src/components/atoms/Badge/Badge.styles';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import theme from 'src/theme/theme';
import { DateFormats, formatDate } from 'src/utils/time';
import {
  Background,
  Container,
  IconContainer,
  DetailsContainer,
  Category,
} from './ReportingReportSummaryCard.styles';

interface Props {
  reportReadableId: string;
  category: string;
  submittedAt: Date;
  status: string;
}

export const ReportingReportSummaryCard = ({
  reportReadableId,
  category,
  submittedAt,
  status,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Background>
      <Container>
        <div>
          <DetailsContainer>
            <IconContainer>
              <StyledIcon
                color={theme.newPalette.neutral.N900}
                className={'uil-file-alt'}
                size="24px"
              />
            </IconContainer>
            <div>
              <Category>{category}</Category>
              <div>
                {t('public.PublicReportCard.reportId')} {reportReadableId}
              </div>
            </div>
          </DetailsContainer>
          <div>
            {t('public.PublicReportCard.submitted')}:{' '}
            {formatDate(submittedAt, DateFormats.DD_MM_YYYY)}
          </div>
        </div>
        <div>
          <Badge
            variant={status.toLowerCase() as BadgeVariant}
            text={t(`ReportStatus.${status}` as TranslationKey)}
          />
        </div>
      </Container>
    </Background>
  );
};
